/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OwnershipEnum = 1 | 2 | 3 | 4;

export const OwnershipEnum = {
    NUMBER_1: 1 as OwnershipEnum,
    NUMBER_2: 2 as OwnershipEnum,
    NUMBER_3: 3 as OwnershipEnum,
    NUMBER_4: 4 as OwnershipEnum
};

